import { FilePdf, FileWord, FileText, FileImage, FileEarmarkPlay } from 'react-bootstrap-icons';

const DEFAULT_ICON_STYLES = {
  pdf: { color: 'red' },
  jpg: { color: 'orange' },
  jpeg: { color: 'orange' },
  png: { color: 'orange' },
  doc: { color: 'green' },
  docx: { color: 'green' },
  txt: { color: 'black' },
  video: { color: 'blue' },
  default: { color: 'black' },
};

export default function getFileIcon(fileType, style = {}, size = '1rem') {
  const iconStyle = {
    ...(DEFAULT_ICON_STYLES[fileType] || DEFAULT_ICON_STYLES.default),
    ...style,
  };

  const Icon = (props) => {
    switch (fileType) {
      case 'pdf':
        return (
          <FilePdf alt="PDF icon" data-cy="pdfIcon" style={iconStyle} size={size} {...props} />
        );
      case 'jpg':
      case 'jpeg':
      case 'png':
        return (
          <FileImage
            alt="Image icon"
            data-cy="imageIcon"
            style={iconStyle}
            size={size}
            {...props}
          />
        );
      case 'doc':
      case 'docx':
        return <FileWord style={iconStyle} size={size} {...props} />;
      case 'txt':
        return <FileText style={iconStyle} size={size} {...props} />;
      case 'video':
        return <FileEarmarkPlay style={iconStyle} size={size} {...props} />;
      default:
        return <FileText style={iconStyle} size={size} {...props} />;
    }
  };

  return Icon;
}
